import { render, staticRenderFns } from "./OrderDeleteTip.vue?vue&type=template&id=68771b06&scoped=true"
import script from "./OrderDeleteTip.vue?vue&type=script&lang=js"
export * from "./OrderDeleteTip.vue?vue&type=script&lang=js"
import style0 from "./OrderDeleteTip.vue?vue&type=style&index=0&id=68771b06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68771b06",
  null
  
)

export default component.exports